import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueOnlineProp from 'vue-online-prop';

Vue.component('v-select2', vSelect);
Vue.use(VueOnlineProp);
Vue.directive('offline', {
    bind(el) {
        el.style.color = '#FFFAF0';
    },
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
